module.exports = __webpack_public_path__ + "img/info-add-on-turn.c6092c0b.svg";